/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryCourierLocationSchema = z.object({
	latitude: z.number(),
	longitude: z.number(),
	updated_at: z.string().describe("Время точки курьера, местное время точки."),
});
